var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.874 7.442c0-.232.077-.445.251-.619L9.51 1.43a.866.866 0 011.24 0 .862.862 0 010 1.238L5.965 7.441l4.9 4.89a.862.862 0 010 1.238.866.866 0 01-1.24 0l-5.5-5.529a.803.803 0 01-.251-.599z",
    fill: "currentColor"
  })));
}

export default SvgChevronLeft;